<template>
  <div>
    <el-card>
      <el-button type="primary" icon="el-icon-s-promotion" size="small" @click="globalBroadcast">全局广播</el-button>
      <el-button type="danger" icon="el-icon-s-operation" size="small" @click="globalOffline">全局下线</el-button>
      <el-button type="success" icon="el-icon-refresh" size="small" @click="reloadAll">重新加载</el-button>
    </el-card>
    <br />
    <m-table
      ref="table"
      :pageModel="pageModel"
      border
      title="应用中心"
      resource="应用"
      title-key="app_name"
      :rules="rules"
    >
      <template v-slot:default>
        <el-table-column label="ID" type="index" align="center" header-align="center"></el-table-column>
        <el-table-column label="应用名" prop="app_name" align="center" header-align="center"></el-table-column>

        <el-table-column
          label="最大连接数"
          width="150"
          prop="max_link_length"
          align="center"
          header-align="center"
        ></el-table-column>
        <el-table-column label="当前在线数" width="150" align="center" header-align="center">
          <template slot-scope="{row}">
            <span>{{apps[row.id] ? `${apps[row.id].link_length}人` :'暂无'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="当前分组数" width="150" align="center" header-align="center">
          <template slot-scope="{row}">
            <span>{{apps[row.id] ? `${getGroupCount(apps[row.id].pool)}个` :'暂无'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="过期时间" prop="timeout_at" align="center" header-align="center"></el-table-column>
        <el-table-column label="秘钥" prop="secret" width="120" align="center" header-align="center">
          <template slot-scope="{row}">
            <el-button
              type="warning"
              v-clipboard:copy="`${row.secret}`"
              v-clipboard:success="function(){$message({type:'success',message:'复制成功'})}"
            >复制秘钥</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" header-align="center">
          <template slot-scope="{row}">
            <el-button size="small" type="primary" icon="el-icon-view">详情</el-button>
            <el-button
              v-if="row.app_type !== 'system'"
              size="small"
              type="warning"
              @click="$refs.table.openDia(row)"
              icon="el-icon-edit"
            >修改</el-button>
            <el-button
              v-if="row.app_type !== 'system'"
              size="small"
              type="danger"
              icon="el-icon-delete"
              @click="$refs.table.del(row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </template>
      <template v-slot:form="{data}">
        <m-form :data="data" />
      </template>
      <template v-slot:search>
        <el-form :model="condition" ref="search">
          <el-row :gutter="5">
            <el-col :span="4">
              <el-form-item prop="name">
                <el-input v-model="condition.name" placeholder="过滤应用名" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="app_type">
                <el-input v-model="condition.app_type" placeholder="过滤应用类型" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="begin_at">
                <el-date-picker
                  style="width:100%"
                  value-format="yyyy-MM-dd"
                  v-model="condition.begin_at"
                  type="date"
                  placeholder="过滤创建日期（大于等于）"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="end_at">
                <el-date-picker
                  style="width:100%"
                  value-format="yyyy-MM-dd"
                  v-model="condition.end_at"
                  type="date"
                  placeholder="过滤创建日期（小于等于）"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button
                icon="el-icon-search"
                type="primary"
                @click="$refs.table.confirmSearch(condition)"
              ></el-button>
              <el-button icon="el-icon-refresh" @click="$refs.search.resetFields()"></el-button>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </m-table>
  </div>
</template>

<script>
import AppCls from "../../models/App";
import Control from "../../models/Control";
import MTable from "../../components/table/index";
import MForm from "./components/appForm";
export default {
  components: { MTable, MForm },
  mounted() {
    this.getApps();
  },
  data: () => ({
    pageModel: new AppCls(),
    contrModel: new Control(),
    rules: {
      app_name: [
        { required: true, message: "请输入应用名称", trigger: "blur" }
      ],
      max_link_length: [
        { required: true, message: "请输入最大连接数", trigger: "blur" }
      ],
      timeout_at: [
        {
          required: true,
          message: "请选择应用过期时间",
          trigger: "change"
        }
      ]
    },
    condition: {
      name: null,
      begin_at: null,
      enb_at: null,
      app_type: null
    },
    apps: {}
  }),
  methods: {
    getApps() {
      let _this = this;
      this.contrModel
        .apps()
        .then(res => {
          _this.apps = res.data;
        })
        .catch(e => {
          _this.$message({
            type: "error",
            message: e
          });
        });
    },
    getGroupCount(pool) {
      return Object.keys(pool).length;
    },
    reloadAll() {
      this.getApps();
      this.$refs.table.getTable();
    },
    globalOffline(){
      let _this = this
      this.$confirm("您确定要让全部用户下线?","警告！",{
        confirmButtonText:"确 定",
        cancelButtonText:"取 消",
        type:"warning"
      }).then(()=>{
        _this.contrModel.globalOffline().then(({message})=>{
          _this.$message({
            type:"success",
            message:message
          })
          _this.getApps()
        }).catch(e=>{
          _this.$message({
            type:"error",
            message:e
          })
        })
      }).catch(()=>{})
    },
    globalBroadcast(){
      let _this = this;
      _this.$prompt('请输入您要广播的内容',"提示",{
        confirmButtonText:"确 定",
        cancelButtonText:"取 消",
      }).then(({value})=>{
        if(!value || value.trim() == ""){
          _this.$message({
            type:"warning",
            message:"请输入广播内容"
          })
          return
        }

        _this.contrModel.globalBroadcast(value).then(({message})=>{
          _this.$message({
            type:"success",
            message:message
          })
        }).catch(e=>{
          _this.$message({
            type:"error",
            message:e
          })
        })
      }).catch(()=>{})
    }
  }
};
</script>

<style>
</style>